<form [formGroup]="addressForm" class="user-info-form">
  <pp-search-select
    [control]="countryCtrl"
    valueField="countryName"
    nameField="countryName"
    [placeholder]="'address.form.placeholder.country' | translate"
    [items]="countriesList()"
    [searchByFields]="['countryCode']"
    [label]="'address.form.label.country' | translate"
    required>
    <ng-template #itemTpl let-item>
      <div class="country">
        <img
          [src]="
            'assets/country-flags/' + item.countryCode.toLowerCase() + '.png'
          "
          onerror="this.src='assets/country-flags/world.png'"
          [alt]="item.countryCode"
          class="icon" />
        <div class="name">{{ item.countryName }}</div>
      </div>
    </ng-template>
  </pp-search-select>

  <pu-simple-input
    required
    [label]="'address.form.label.city' | translate"
    formControlName="city">
  </pu-simple-input>

  <pu-simple-input
    required
    [label]="'address.form.label.region' | translate"
    formControlName="region">
  </pu-simple-input>

  <pu-simple-input
    required
    [label]="'address.form.label.street' | translate"
    formControlName="street">
  </pu-simple-input>

  <div class="line">
    <pu-simple-input
      required
      [label]="'address.form.label.houseNumber' | translate"
      formControlName="houseNumber">
    </pu-simple-input>

    <pu-simple-input
      required
      [label]="'address.form.label.apartment' | translate"
      formControlName="apartment">
    </pu-simple-input>
  </div>

  <pu-simple-input
    [errorDictionary]="errorDictionary"
    required
    [label]="'address.form.label.postalCode' | translate"
    formControlName="postal">
  </pu-simple-input>

  @if (hasChanges()) {
    <button
      class="discard"
      type="button"
      puButton
      size="m"
      uiType="quaternary"
      (click)="setInitialValues()"
      translate="editUser.form.btn.discardChanges"></button>
  }

  <div class="pp-form-actions">
    <button
      type="button"
      puButton
      size="m"
      uiType="secondary"
      (click)="closeDialog.emit(false)"
      translate="editUser.form.btn.close"></button>

    @if (!readonlyRights()) {
      <button
        type="button"
        puButton
        size="m"
        [disabled]="addressForm.invalid || !hasChanges()"
        uiType="primary"
        (click)="submitForm()"
        translate="editUser.form.btn.save"></button>
    }
  </div>
</form>
